import { ArrowRight, Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';

/**
 * Sprint 5b.1.5 v2 — empty state quand `effective.length === 0` (cas D/E §5.7).
 *
 * Pas d'AO suggéré tant que le tenant n'a pas configuré son profil commercial
 * (au minimum NAF SIRENE + optionnellement extensions CPV).
 */
export function EmptyStateNoProfile() {
  return (
    <Card className="p-8 text-center max-w-2xl mx-auto">
      <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-primary/10 text-primary mb-4">
        <Sparkles className="h-6 w-6" />
      </div>
      <h2 className="text-lg font-semibold mb-2">
        Le sourcing automatique n'est pas encore activé
      </h2>
      <p className="text-sm text-muted-foreground mb-6">
        Pour recevoir des suggestions d'AO pertinentes, configurez votre profil commercial :
        code NAF (récupéré automatiquement depuis SIRENE) ou secteurs CPV ciblés en
        extension. Sans ce périmètre métier, le système ne peut pas filtrer les annonces
        pour vous.
      </p>
      <Button asChild>
        <Link to="/dossier-company">
          Aller configurer mon profil
          <ArrowRight className="h-4 w-4 ml-2" />
        </Link>
      </Button>
    </Card>
  );
}
